module.exports = __webpack_public_path__ + "static/media/noun_chart bar.d49d0cd7.svg";